import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import CheckFilterResultDetail from './check_filter_result_detail';
import Grow from '@material-ui/core/Grow';
import {
  stableSort,
  getSorting
} from './utils/sort';
import { viewTitleStyle }from './constants';

function createData(results) {
  //TODO validate results
  return results.map((r) => {
    return {id: r.rule, rule: r.rule, violated: r.draws.length, detail: r.draws}
  });
}

const rows = [
  {
    id: 'rule',
    label: 'Filter Rule'
  }, {
    id: 'violated',
    label: 'Violated'
  }, {
    id: 'detail',
    label: 'Detail'
  }
];

const tableHeadStyles = theme => ({
  headCell: {
    textAlign: 'left',
    fontWeight: '400',
    padding: '0 0 0 20px',
    width: '100px',
  }
});

class EnhancedTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {classes, order, orderBy} = this.props;
    return (<TableHead>
      <TableRow>
        {
          rows.map(row => {
            return (<TableCell className={classes.headCell} key={row.id} sortDirection={orderBy === row.id
                ? order
                : false}>
              <Tooltip title="Sort" placement={'bottom-end'} enterDelay={300}>
                <TableSortLabel active={orderBy === row.id} direction={order} onClick={this.createSortHandler(row.id)}>
                  {row.label}
                </TableSortLabel>
              </Tooltip>
            </TableCell>);
          }, this)
        }
      </TableRow>
    </TableHead>);
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired
};

EnhancedTableHead = withStyles(tableHeadStyles)(EnhancedTableHead);

const toolbarStyles = theme => ({
  spacer: {
    flex: '1 1 100%'
  },
  actions: {
    color: theme.palette.text.secondary
  },
  title: viewTitleStyle,
});

let EnhancedTableToolbar = props => {
  const {classes, draws} = props;

  return (<div>
    <h1 className={classes.title}>
      Rule Statistics Over {draws.length} Historical Draws Since {draws[draws.length - 1]['drawDate']}
    </h1>
    <div className={classes.spacer}/>
  </div>);
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = theme => ({
  root: {
    margin: '10px 15px 0 auto',
    padding: '10px',
    width: '530px',
    boxSizing: 'border-box',
  },
  table: {
    minWidth: '380px'
  },
  tableWrapper: {
    overflowX: 'auto'
  }
});

class EnhancedTable extends React.Component {

  state = {
    order: 'asc',
    orderBy: 'violated',
    data: createData(this.props.results),
    page: 0,
    rowsPerPage: 8,
    draws: this.props.draws
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({order, orderBy});
  };

  handleChangePage = (event, page) => {
    this.setState({page});
  };

  handleChangeRowsPerPage = event => {
    this.setState({rowsPerPage: event.target.value});
  };

  render() {
    const {classes} = this.props;
    const {data, order, orderBy, rowsPerPage, page} = this.state;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    return (
      <Grow in={true}>
        <Paper className={classes.root}>
          <EnhancedTableToolbar draws={this.state.draws}/>
          <hr/>
          <div className={classes.tableWrapper}>
            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={this.handleRequestSort} rowCount={data.length} draws={this.state.draws}/>
              <TableBody>
                {
                  stableSort(data, getSorting(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                    return (                  
                      <TableRow hover={true} tabIndex={-1} key={n.id}>
                        <TableCell component="th" scope="row">
                          {n.rule}
                        </TableCell>
                        <TableCell>{n.violated}</TableCell>
                      <TableCell><CheckFilterResultDetail rule={n.rule} draws={n.detail}/></TableCell>
                      </TableRow>);
                  })
                }
                {
                  emptyRows > 0 && (<TableRow style={{
                      height: 49 * emptyRows
                    }}>
                    <TableCell colSpan={3}/>
                  </TableRow>)
                }
              </TableBody>
            </Table>
          </div>
          <TablePagination rowsPerPageOptions={[5]} component="div" count={data.length} rowsPerPage={rowsPerPage} page={page} backIconButtonProps={{
              'aria-label' : 'Previous Page'
            }} nextIconButtonProps={{
              'aria-label' : 'Next Page'
            }} onChangePage={this.handleChangePage} onChangeRowsPerPage={this.handleChangeRowsPerPage}/>
        </Paper>
      </Grow>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(EnhancedTable);
